import { useEffect, useRef } from "react";
import { platoUrls } from "../constants";
import { useFeatureEnabled } from "@/hooks";
import { useI18n } from "@/contexts/i18n";
import { usePlatoAvailable, usePlatoSettings } from "@/contexts/contact";
import { useEnv } from "@/contexts/cdpConfig";
/**
 * This Hook will load the Plato Widget if it is enabled
 * Loading will occur after the BFF call since the platoSettings are required
 */
export const useLoadPlato = () => {
    const { locale } = useI18n();
    const scriptsLoaded = useRef(false);
    const env = useEnv();
    // Plato feature is "enabled" for the current Brand
    const platoEnabled = useFeatureEnabled("plato");
    // Plato is "availaible" for the current Agency / Classified
    const platoAvailable = usePlatoAvailable();
    // platoSettings are provided by the BFF
    const platoSettings = usePlatoSettings();
    useEffect(() => {
        if (platoEnabled &&
            platoAvailable &&
            !scriptsLoaded.current &&
            platoSettings) {
            const platoWidgetScript = document.createElement("script");
            platoWidgetScript.src = platoUrls[env];
            const platoSettingsScript = document.createElement("script");
            platoSettingsScript.innerHTML = `window.platoSettings = {
        source: "${platoSettings === null || platoSettings === void 0 ? void 0 : platoSettings.source}",
        reference: "${platoSettings === null || platoSettings === void 0 ? void 0 : platoSettings.reference}",
        agencyId: "${platoSettings === null || platoSettings === void 0 ? void 0 : platoSettings.agencyId}",
        locale: "${locale}",
        }
        `;
            platoWidgetScript.id = "plato.widget";
            platoSettingsScript.id = "plato.settings";
            platoWidgetScript.async = true;
            platoSettingsScript.async = true;
            // Settings shoulb be set before the Widget is Loaded
            document.head.appendChild(platoSettingsScript);
            document.head.appendChild(platoWidgetScript);
            scriptsLoaded.current = true;
        }
    }, [platoSettings, locale, platoEnabled, env, platoAvailable]);
};
